import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Fade from "@mui/material/Fade";
import {Box, Grid, Typography, styled} from "@mui/material";
import Button from "../../components/Button";
import CustomTextField from "../../components/Textfield";
import {getSx} from "../../components/Modal/style";
import {useDispatch} from "react-redux";
import {showToast} from "../../store/slices/common";
import {createCategory, updateCategory} from "../../http/auth";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import Spinner from "../../components/Spinner";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Fade ref={ref} {...props} />;
});

const CustomDialog = styled(Dialog)(() => ({
    "& .MuiDialog-paper": {
        width: "1200px", padding: "30px", borderRadius: "20px",
    }, "& .MuiPaper-root": {maxWidth: "400px"}, "& .MuiDialogActions-root": {},
}));

export default function CreateCategory({
                                           open, setOpen, type, getCategories, editableRow, isEdit, setPage,
                                       }) {
    const [formData, setFormData] = React.useState({});
    const [titleErr, setTitleErr] = React.useState("");
    const [subCategories, setSubCategories] = React.useState([]);
    const [subCategoryObj, setSubCategoryObj] = React.useState({
        en: "", hi: "", fr: "", es: "",
    });
    const [newCat, setNew] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const classes = getSx(true);
    const dispatch = useDispatch();

    React.useEffect(() => {
        if (!open) {
            setFormData({});
            setTitleErr("");
        }
        if (open) {
            setFormData(editableRow);
        }
    }, [open]);

    React.useEffect(() => {
        setFormData(editableRow);
        setSubCategories(editableRow?.subTitle || []);
    }, [editableRow]);

    const validateTitle = (value) => {
        return !!value.trim();
    };

    const onChangeHandler = (event) => {
        // if (
        //   event.target.name === "title" &&
        //   titleErr &&
        //   validateTitle(event.target.name)
        // ) {
        //   setTitleErr("");
        // }
        setFormData({
            ...formData, title: {
                ...formData?.title, [event.target.name]: event.target.value,
            },
        });
    };

    const onSubCategoryChange = (event) => {
        setSubCategoryObj((prev) => ({
            ...prev, [event.target.name]: event.target.value,
        }));
    };

    const onClickHandler = async () => {
        try {
            setLoading(true);
            const otherPayload = isEdit ? {
                title: formData.title, type: type.toLowerCase(), categoryId: editableRow?.id,
            } : {...formData, type: type.toLowerCase()};
            const expensePayload = {...otherPayload, subTitle: subCategories};
            const payload = type === "Expenses" ? expensePayload : otherPayload;
            const res = isEdit ? await updateCategory(payload) : await createCategory(payload);
            if (res.status === 200) dispatch(showToast({msg: "category created successfully", color: "success"}));
            !isEdit && setPage(1);
            isEdit ? getCategories(type.toLowerCase()) : getCategories(type.toLowerCase(), 1);
        } catch (error) {
            // dispatch(showToast({ msg: "Something went wrong", color: "error" }));
        } finally {
            setLoading(false);
        }
        setOpen(false);
        setFormData({});
    };

    // const getIsFormDisabled = () => {
    //   return !formData?.title?.en?.trim();
    // };

    const disabled = false;
    // type === "Expenses" ? getIsFormDisabled() : !formData?.title?.en.trim();

    //only for required-name and building
    const setError = (value, errFn, err) => {
        if (!value) {
            errFn(err);
        }
    };

    const handleBlur = (event) => {
        switch (event.target.name) {
            case "title":
                setError(formData.title, setTitleErr, "Title is required!");
                break;
            default:
                break;
        }
    };
    const closeModalHandler = () => {
        setOpen(false);
    };
    console.log(subCategories, "subCategories");
    const addSubCategoryHandler = (name) => {
        let subCategoryCopy = [...subCategories];
        subCategoryCopy.push({
            en: subCategoryObj?.en, hi: subCategoryObj?.hi, fr: subCategoryObj?.fr, es: subCategoryObj?.es,
        });
        // subCategoryCopy = [{ en: enArr, hi: hiArr, fr: frArr, es: esArr }];
        // setFormData({ ...formData, subCat: "" });
        setSubCategoryObj({en: "", hi: "", fr: "", es: ""});
        setSubCategories(subCategoryCopy);
    };
    console.log(newCat, "fdsfsdf");
    const removeSubCategoryHandler = (category) => {
        const subCategoryCopy = [...subCategories];
        const filteredArr = subCategoryCopy.filter((item) => item.en != category?.en);
        // subCategoryCopy.splice(index, 1);
        setSubCategories(filteredArr);
    };

    return (<CustomDialog
        open={open}
        keepMounted
        onClose={() => setOpen(false)}
        TransitionComponent={Transition}
        sx={{
            "& .MuiPaper-root": {
                maxWidth: "1200px", paddingLeft: 0, paddingRight: 0,
            },
        }}
    >
        {loading && <Spinner/>}
        <DialogContent sx={{padding: "8px 20px"}}>
            <Box sx={{...classes.subTitleContainer, gap: "1rem"}}>
                <Box sx={{width: '100%'}}>
                    <Typography
                        sx={{
                            fontSize: "24px", width: '100%', textAlign: "left", marginBottom: '15px'
                        }}
                    >
                        {isEdit ? "Edit Category" : "Add Category"}
                    </Typography>

                    <Typography
                        sx={{
                            fontSize: "18px", width: '100%', textAlign: "left",
                        }}
                    >
                        Category<span style={{color: "red"}}>*</span>
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid md={3} item>
                            <CustomTextField
                                name="en"
                                placeholder="Title in english"
                                value={formData.title?.en || ""}
                                onChange={onChangeHandler}
                                onBlur={handleBlur}
                                type="text"
                            />
                        </Grid>
                        <Grid md={3} item>
                            <CustomTextField
                                name="hi"
                                placeholder="Title in hindi"
                                value={formData.title?.hi || ""}
                                onChange={onChangeHandler}
                                onBlur={handleBlur}
                                type="text"
                            />
                        </Grid>
                        <Grid md={3} item>
                            <CustomTextField
                                name="fr"
                                placeholder="Title in french"
                                value={formData.title?.fr || ""}
                                onChange={onChangeHandler}
                                onBlur={handleBlur}
                                type="text"
                            />
                        </Grid>
                        <Grid md={3} item>
                            <CustomTextField
                                name="es"
                                placeholder="Title in spanish"
                                value={formData.title?.es || ""}
                                onChange={onChangeHandler}
                                onBlur={handleBlur}
                                type="text"
                            />
                        </Grid>
                    </Grid>
                    {titleErr && (<Typography
                        sx={{
                            fontSize: "12px", color: "red", fontWeight: 400,
                        }}
                    >
                        {titleErr}
                    </Typography>)}
                </Box>
                {type === "Expenses" && (<>
                    <Box sx={{width: '100%'}}>
                        <Typography
                            sx={{
                                fontSize: "18px", width: '100%', textAlign: 'left'
                            }}
                        >
                            Sub Category<span style={{color: "red"}}>*</span>
                        </Typography>
                        <Grid container spacing={2}>
                            <Grid md={2.5} item>
                                <CustomTextField
                                    name="en"
                                    placeholder="Enter a subCategory"
                                    onChange={onSubCategoryChange}
                                    value={subCategoryObj?.en || ""}
                                    onBlur={handleBlur}
                                    type="text"
                                    isCategory={true}
                                    disableCategory={!formData?.subCat?.length}
                                />
                            </Grid>
                            <Grid md={2.5} item>
                                <CustomTextField
                                    name="hi"
                                    placeholder="Enter a subCategory"
                                    onChange={onSubCategoryChange}
                                    value={subCategoryObj?.hi || ""}
                                    onBlur={handleBlur}
                                    type="text"
                                    isCategory={true}
                                    // addSubCategory={addSubCategoryHandler}
                                    disableCategory={!formData?.subCat?.length}
                                />
                            </Grid>
                            <Grid md={2.5} item>
                                <CustomTextField
                                    name="fr"
                                    placeholder="Enter a subCategory"
                                    onChange={onSubCategoryChange}
                                    value={subCategoryObj.fr || ""}
                                    onBlur={handleBlur}
                                    type="text"
                                    isCategory={true}
                                    disableCategory={!formData?.subCat?.length}
                                />
                            </Grid>
                            <Grid md={2.5} item>
                                <CustomTextField
                                    name="es"
                                    placeholder="Enter a subCategory"
                                    onChange={onSubCategoryChange}
                                    value={subCategoryObj?.es || ""}
                                    onBlur={handleBlur}
                                    type="text"
                                    isCategory={true}
                                    disableCategory={!formData?.subCat?.length}
                                />
                            </Grid>
                            <Grid md={2} item>
                                <Button style={{width: '100%'}} onClick={addSubCategoryHandler}> Add</Button>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box sx={{
                        width:'100%'
                    }}>
                        <Grid container spacing={2}>
                        {subCategories.map((category) => {
                            return (<>
                                <Grid md={2.6} item>
                                    <Box
                                        sx={{
                                            borderRadius: "12px",
                                            padding: "5px 10px",
                                            fontSize: "14px",
                                            backgroundColor: "#0832DE",
                                            color: "white",
                                            minHeight:'40px'
                                        }}
                                    >
                                        {category?.en}
                                    </Box>
                                </Grid>
                                <Grid md={2.6} item>
                                    <Box
                                        sx={{
                                            borderRadius: "12px",
                                            padding: "5px 10px",
                                            fontSize: "14px",
                                            backgroundColor: "#0832DE",
                                            color: "white",
                                            minHeight:'40px'
                                        }}
                                    >
                                        {category?.hi}
                                    </Box>
                                </Grid>
                                <Grid md={2.6} item>
                                    <Box
                                        sx={{
                                            borderRadius: "12px",
                                            padding: "5px 10px",
                                            fontSize: "14px",
                                            backgroundColor: "#0832DE",
                                            color: "white",
                                            minHeight:'40px'
                                        }}
                                    >
                                        {category?.fr}
                                    </Box>
                                </Grid>
                                <Grid md={2.6} item>
                                    <Box
                                        sx={{
                                            borderRadius: "12px",
                                            padding: "5px 10px",
                                            fontSize: "14px",
                                            backgroundColor: "#0832DE",
                                            color: "white",
                                            minHeight:'40px'
                                        }}
                                    >
                                        {category?.es}
                                    </Box>
                                </Grid>
                                <Grid item md={1.6}>
                                    <Button style={{width: '100%'}}
                                        onClick={() => removeSubCategoryHandler(category)}
                                    >
                                        Remove
                                    </Button>
                                </Grid>
                            </>);
                        })}
                    </Grid>
                    </Box>
                </>)}
            </Box>
        </DialogContent>
        <DialogActions
            disableSpacing={false}
            sx={{...classes.buttonWrapper, justifyContent: "center"}}
        >
            <Button
                style={{...classes.button, width: "100px", borderRadius: "12px"}}
                label={isEdit ? "Update" : "Create"}
                onClick={onClickHandler}
                disabled={disabled}
            />
            <Button
                style={{...classes.button, width: "100px", borderRadius: "12px"}}
                label="Cancel"
                onClick={closeModalHandler}
            />
        </DialogActions>
    </CustomDialog>);
}
